import mitt from 'mitt';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var index = (function () {
	var eventsMap = {};
	var instance = mitt(eventsMap);
	return _extends({}, instance, {
		off: function off(type, handler) {
			if (!type) {
				Object.keys(eventsMap).forEach(function (key) {
					delete eventsMap[key];
				});
				return;
			}
			instance.off(type, handler);
		},
		once: function once(type, handler) {
			instance.on(type, function onceHandler(data) {
				instance.off(type, onceHandler);
				handler(data);
			});
		}
	});
});

export default index;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@livechat/mitt/dist/livechat-mitt.es.js
// module id = 591
// module chunks = 0